export const PROMO_END = new Date("2026-10-01T00:00:00+02:00").getTime();

export const isPromoActive = () => Date.now() < PROMO_END;

const STORAGE_KEY = "ap_promo_closed_at";
const DISMISS_DURATION = 24 * 60 * 60 * 1000;

export const isPromoDismissed = () => {
  try {
    const ts = Number(localStorage.getItem(STORAGE_KEY));
    return ts && Date.now() - ts < DISMISS_DURATION;
  } catch {
    return false;
  }
};

export const dismissPromo = () => {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    /* stockage indisponible */
  }
};

export const goToPricing = (navigate) => {
  navigate("/#tarifs");
  setTimeout(() => {
    const el = document.querySelector("#tarifs");
    if (!el) return;
    const stack = document.querySelector('[data-testid="header-stack"]');
    const offset = -((stack?.offsetHeight || 64) + 12);
    if (window.__lenis) window.__lenis.scrollTo(el, { offset });
    else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY + offset, behavior: "smooth" });
  }, 180);
};
